module.exports = __webpack_public_path__ + "img/photos-icon.0ccb6c19.svg";